module.exports = __webpack_public_path__ + "static/media/info.8d81efe2.svg";